<template>
  <div class="tg-action">
    <div class="tg-action-item" @click="toCharge">
      <img :src="require('@/lobby_common/assets/deposit.png')" class="tg-action-icon" alt="" />
      <span class="tg-action-name">{{ $t("Datalang.newly_TG_recharge") }}</span>
    </div>
    <div class="tg-action-item" @click="toRecharge">
      <img :src="require('@/lobby_common/assets/with.png')" class="tg-action-icon" alt="" />
      <span class="tg-action-name">{{ $t("Datalang.newly_TG_withdraw") }}</span>
    </div>
    <div class="tg-action-item">
      <!-- <img :src="require('@/lobby_common/assets/currency.png')" class="tg-action-icon" alt="">
        <span class="tg-action-name">
          <span>切换货币</span>
          <i class="el-icon-arrow-down color-white"></i>
        </span> -->
      <el-dropdown
        @command="handleCheck"
        ref="messageDrop"
        trigger="click"
        @click.native="dropdown"
        @visible-change="visibleChange"
        :hide-on-click="true"
        :disabled="
          !!isGame() ||
          getAppConfig.withdrawMode === 'WITHDRAW_MODE_LIMIT' ||
          getAppConfig.withdrawMode === 'WITHDRAW_MODE_CLOSE'
        "
      >
        <label class="el-dropdown-link" style="position: relative; display: flex; align-items: center">
          <img :src="require('@/lobby_common/assets/currency.png')" class="tg-action-icon" alt="" />
          <span class="tg-action-name">
            <span>{{ $t("Datalang.newly_currency") }}</span>
            <i class="el-icon-arrow-down color-white"></i>
          </span>
        </label>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item class="qbHeaer">
            <div align="left">
              {{ $t("Datalang.Wallet_BTM_selectdefaultwallet") }}
              <span v-if="rateList.length > 0" class="el-icon-question" @click="onShowInfoModal(1)"></span>
            </div>
          </el-dropdown-item>
          <el-dropdown-item
            v-for="(item, i) in UserCoins"
            :command="item.coinCode"
            :key="i"
            class="qbItem"
            :disabled="curCoin.coinCode === item.coinCode" 
          >
            <div
              class="qbDiv"
              v-if="isTgAppCoinCode(item)"
            >
              <img :src="$utils.returnImgUrl(item.coinIcon)" alt />
              <span v-if="item.isExperienceCoinCode">{{ $t('Datalang.home_exprience') }}&nbsp;&nbsp;</span>
              <span v-else>{{ item.coinCode }}&nbsp;&nbsp;</span>
              <div class="chips">
                <div class="symbol_coin">
                  {{ divideSymbol(item.isExperienceCoinCode ? item.experience : item.chips) }}
                </div>
              </div>
            </div>
            <div class="experienceDiv" v-if="item.isExperienceCoinCode">
              <ExperienceWallet :experienceObj="item"/>
            </div>
          </el-dropdown-item>
          <el-dropdown-item class="qbFooter">
            <span class="walletBtn" :class="{ first: isFirst }" @click="toWallet" align="center">
              {{ $t("Datalang.Wallet_BTM_walletdetails") }}
            </span>
          </el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </div>

    <PopupDialog
      id="hrate_modal"
      :fullscreen="true"
      ref="PopupDialog"
      :dataOpt="{
        title: infoType === 1 ? $t('Datalang.Wallet_BTM_switchwalletdescription') : $t('Datalang.home_exprience'),
      }"
      :show.sync="PopupWindowShow"
      @close="closeFun"
    >
      <template #center>
        <div class="modal-info">
          <div v-if="infoType === 1">
            <p>1. {{ $t("Datalang.Wallet_TEXT_circulationcurrenc") }}</p>
            <template v-if="rateList.length">
              <div v-for="item in rateList" :key="item.id">
                1{{ item.fromCoin }} ≈ {{ item.rate }} {{ item.toCoin }}
              </div>
            </template>
            <p>2. {{ $t("Datalang.Wallet_TEXT_defaultwallet") }}</p>
          </div>
          <div v-else>
            <p>{{ $t("Datalang.home_withdrawable") }}</p>
          </div>
          <div class="btn-content">
            <el-button round type="primary" @click="closeFun">{{ $t("Datalang.Withdrawl_TIP_getit") }}</el-button>
          </div>
        </div>
      </template>
    </PopupDialog>
  </div>
</template>
<script>
import { mapGetters, mapActions } from "vuex";
import fanhuibtn from "@/assets/chage/Back_btn.png";
import celanbtn from "@/assets/home/celan_btn.png";
// import Jb from "@/assets/img/jb.png";
// import UserIcon from "@/assets/img/txk.png";
import { divideAccuracy, divideSymbol, isGame, isInTelegramWebApp } from "@/lobby_common/utils/utils.js";
import { killPlayerUser } from "@/lobby_common/api/game_gen";
import { selectWallet } from "@/lobby_common/api/user_gen";
import { getCoinExchangeRateData } from "@/lobby_common/utils/utils.js";
import PopupDialog from "@/components/PopupDialog";
import { setLocale } from "@/lobby_common/locale";
import { updateUserLanguage } from "@/lobby_common/api/user_gen.js";
import { cacheKeys } from "@/lobby_common/utils/commonEnum.js";
import ExperienceWallet from "@/components/experienceWallet/index.vue";
import { clearAllDB } from '@/lobby_common/utils/jsonCache.js'
export default {
  name: "h-header",
  components: { PopupDialog, ExperienceWallet },
  props: ["isMenu", "isTg"],
  data() {
    return {
      killPlayerUser,
      setLocale,
      fanhuibtn,
      celanbtn,
      // Jb,
      // UserIcon,
      divideAccuracy,
      divideSymbol,
      // curCoin: {},
      obj: {},
      UserCoins: [],
      PopupWindowShow: false,
      // rateList: [],
      isFirst: false,
      isHome: true,
      isGame: isGame,
      isApi: false,
      infoType: 1,
      cacheKeys,
      // rateLoading: false,
      // coinExchangeRate: [],
    };
  },
  watch: {
    getUserCoins: {
      handler: function () {
        this.handeleUserCoins();
      },
      deep: true,
      immediate: true,
    },
    "$route.params": {
      handler(newval, oldval) {
        if (this.$route.path === "/home") {
          this.isHome = true;
        } else {
          this.isHome = false;
        }
      },
      deep: true,
      immediate: true,
    },
  },
  async created() {},
  computed: {
    // 是否有体验彩金钱包
    hasExperienceWallet() {
      return this.getAppConfig?.wallets?.includes("EXPERIENCE_WALLET") || false;
    },
    isAndroid() {
      const u = navigator.userAgent;
      const android = u.indexOf("Android") > -1 || u.indexOf("Linux") > -1; // 安卓机！
      return android;
    },
    getAppConfig() {
      return this.$store.getters.getPacketConfig?.appConfig || {};
    },
    topNavigationTemplate() {
      return this.$store.getters.getPacketConfig?.topNavigationTemplate?.h5 || null;
    },
    getlangIcon() {
      const arr =
        this.locales.filter((v) => {
          return v.locale === this.langSelect;
        }) || [];
      return arr[0] ? arr[0].icon : "";
    },
    locales() {
      return this.$store.getters.getLocalesList;
    },
    langSelect() {
      return this.$store.getters.getLang;
    },
    getData() {
      return this.$store.getters.getData;
    },
    getUserCoins() {
      return this.$store.getters.getUserCoins;
    },
    curCoin() {
      return this.$store.getters.getCurCoin || {};
    },
    rateList() {
      return this.$store.getters.getRateList || [];
    },
    coinExchangeRate() {
      return this.$store.getters.getCoinExchangeRate || [];
    },
    rateLoading() {
      return this.$store.getters.getRateLoading;
    },
    coinSymbol() {
      return this.$store.getters.user?.coin_symbol;
    },
    logo() {
      return this.$utils.returnImgUrl(this.$store.getters.getPacketConfig?.site?.indexLogo);
    },
    isLogin() {
      return this.$store.getters.login;
    },
    userData() {
      return this.$store.getters.user;
    },
    activityshowdata() {
      return this.$store.getters.activityshow;
    },
    ...mapGetters(["menuIsShow"]),
    menuItems() {
      const items = [
        {
          title: this.$t("Datalang.HomePage_BTM_login"),
          type: "primary",
          value: 0,
        },
        {
          title: this.$t("Datalang.HomePage_BTM_register"),
          type: "primary",
          value: 1,
        },
      ];
      return items;
    },
    taken() {
      return this.$store.getters.taken;
    },
    isMobile() {
      return this.$store.getters.getIsMobile;
    },
    userInfo() {
      return JSON.parse(JSON.stringify(this.$store.getters.user));
    },
    defaultCoinCode() {
      return this.userInfo.coinCode;
    },
  },
  methods: {
    ...mapActions(["setMenuBar"]),
    async changeFun(val) {
      await clearAllDB();
      let code = 0;
      if (this.$store.getters.taken) {
        const res = (await updateUserLanguage({ language: val })) || {};
        code = res.code;
      }
      if (code === 0) {
        this.setLocale(val);
        this.$router.push("/home");
        // this.$Bus.$emit("reload")
        setTimeout(() => {
          window.location.reload();
        }, 100);
      }
    },
    handeleUserCoins() {
      const obj = this.getUserCoins;
      const data = { ...obj };
      const wallets = data.wallets || [];
      if (wallets.length === 0) {
        return false;
      }
      let UserCoins = [...wallets];
      // 当前选中的币种
      UserCoins = UserCoins.map((v) => {
        // 充值 可提 彩金
        v.chips = this.divideAccuracy(
          Number(v.rechargeWallet) + Number(v.withdrawWallet) + Number(v.bonusWallet),
          v.accuracy
        );
        v.isDefaultCoin = v.coinCode === this.defaultCoinCode; // 当前货币是否为会员货币
        // 体验彩金
        v.experience =
          this.hasExperienceWallet ? this.divideAccuracy(Number(v.experienceWallet), v.accuracy) : 0;
        return { ...v };
      });
      // 当前选中的币种
      const selectedCoinCode = data.selectedCoinCode || UserCoins[0]?.coinCode;

      this.$set(this, "UserCoins", UserCoins);
      if (!this.rateList.length) {
        this.getRateList(data);
      }
      this.afterGetCoincode(selectedCoinCode);
    },
    menuClick() {
      console.log("this.menuIsShow", this.menuIsShow);
      this.setMenuBar(!this.menuIsShow);
    },
    visibleChange(val) {
      if (val) {
        // console.log(val);
        const flag = localStorage.getItem("firstVisit");
        // console.log(flag, "flag");
        this.isFirst = !flag;
        // this.$refs.messageDrop.visible = false;
      }
    },
    async onShowInfoModal(type) {
      this.infoType = type;
      this.PopupWindowShow = true;
    },
    closeFun() {
      this.PopupWindowShow = false;
    },

    async getRateList(coinList = {}) {
      // 共用汇率loading，只请求一次汇率接口
      if (this.rateLoading) return;
      this.$store.commit("setRateLoading", true);
      const arr = coinList.wallets || [];
      const checkedCoin = arr.find((item) => item.coinCode === coinList.selectedCoinCode) || {};
      let dataList = [];
      if (this.coinExchangeRate.length) {
        dataList = this.coinExchangeRate;
      } else {
        const { code, data } = await getCoinExchangeRateData();
        if (code === 0) {
          dataList = data.list || [];
          // 存汇率表
          this.$store.commit("setCoinExchangeRate", dataList);
        }
      }
      const walletCoin = arr.map((item) => item.coinCode) || [];
      const brr = dataList.filter((item) => item.toCoin === checkedCoin.coinCode) || [];
      const _arr = brr.filter((item) => walletCoin.includes(item.fromCoin)) || [];
      // 存当前货币汇率数据
      this.$store.commit("setRateList", _arr);
      this.$store.commit("setRateLoading", false);
    },
    // 前往钱包
    toWallet() {
      if (this.isMenu) {
        this.setMenuBar(false);
      }
      this.$router.push("/user/hWallet");
    },
    afterGetCoincode(command) {
      if (!command) return false;
      // const { code } = await this.killPlayerUser({});
      // if (code !== 0) {
      //   return;
      // }
      const arr = this.UserCoins.filter((v) => {
        return v.coinCode === command;
      });
      if (arr && arr.length) {
        this.$store.commit("setCurCoin", arr[0]);
      }
      localStorage.setItem("coinCode", command);
      localStorage.setItem("Cur_Chips", this.curCoin.isExperienceCoinCode ? this.curCoin.experience : this.curCoin.chips)
      this.$store.commit("setSelectCoin", command);
    },
    // 跳转充值
    toCharge() {
      this.$Bus.$emit("showCharge", { show: true });
    },
    toRecharge() {
      this.$Bus.$emit("showExchange", { show: true });
    },
    dropdown() {
      if (this.$refs.messageDrop.visible === true) {
        this.$refs.messageDrop.visible = false;
      } else {
        this.$eventPost("currency_display_click");
        this.$refs.messageDrop.visible = true;
      }
    },
    async handleCheck(val) {
      console.log(val);
      //   this.dropdown();
      // this.handleCheckCoinCode(val);
      if (!val) return false;
      if(val.includes('experience')) return false
      const { code } = await this.killPlayerUser({});
      if (code !== 0) {
        return;
      }
      const arr = this.UserCoins.filter((v) => {
        return v.coinCode === val;
      });
      if (arr && arr.length) {
        this.$store.commit("setCurCoin", arr[0]);
      }
      localStorage.setItem("coinCode", val);
      localStorage.setItem("Cur_Chips", this.curCoin.isExperienceCoinCode ? this.curCoin.experience : this.curCoin.chips)
      selectWallet({ coinCode: val }).then((res) => {
        this.$store.commit("setSelectCoin", val);
        if (isGame()) {
          // 在游戏中就刷新页面
          window.location.reload();
        }
        this.$Bus.$emit("reload");
      });
    },
    // 切换货币
    async handleCheckCoinCode(command, once = false) {
      if (!command) return false;
      // const { code } = await this.killPlayerUser({});
      // if (code !== 0) {
      //   return;
      // }
      const arr = this.UserCoins.filter((v) => {
        return v.coinCode === command;
      });
      if (arr && arr.length) {
        this.$store.commit("setCurCoin", arr[0]);
      }
      localStorage.setItem("coinCode", command);
      localStorage.setItem("Cur_Chips", this.curCoin.isExperienceCoinCode ? this.curCoin.experience : this.curCoin.chips)
      await selectWallet({ coinCode: command }).then((res) => {
        this.$store.commit("setSelectCoin", command);
        if (!once) {
          if (isGame()) {
            // 在游戏中就刷新页面
            window.location.reload();
          }
        }
      });
    },
    showWalletBalance(e) {
      this.$router.push("/hWallet/hWalletDetail");
    },
    clickFun(type) {
      const objStr = {
        0: "Login",
        1: "Register",
      };
      this.$Bus.$emit("showLogin", { show: true, tab: objStr[type] });
    },
    toLink(path) {
      // localStorage.setItem("after_quick", true);
      if (this.isMenu) {
        this.setMenuBar(false);
      }
      this.$router.push(path || "/");
    },
    goBackPage() {
      const url = window.location.href;
      console.log(url);
      // if (url.includes("/activityDetail/")) {
      //   window.history.back();
      //   return;
      // }
      const name = this.$route.name;
      if (name === "homeSearch" || this.cacheKeys.includes(name.slice(0, -1))) {
        this.$router.push("/home");
        return;
      }
      if (url.includes("/activityDetail/")) {
        window.history.back();
        return;
      }
      if (url.includes("/rewardInvite")) {
        this.$router.push("/home");
        return;
      }
      if (Number(this.$router.history?.current?.params?.canTestPlay) === "STATUS_BOOL_TRUE") {
        // 专业代进来的试玩，没有上层历史路由，直接返回首页
        this.$router.push("/home");
        return;
      }

      const isSelfStudy = this.$route.query?.brand || "";
      if (isSelfStudy === "2") {
        this.$router.push("/home");
      }

      // 判断是否有历史记录
      if (window.history.length > 1) {
        this.$router.go(-1); // 返回上一级
      } else {
        this.$router.push("/home"); // 返回首页
      }
      // this.$router.go(-1);
    },
    onLinkService() {
      this.$router.push("/user/hCustomerService");
    },
  },
  activated() {},
};
</script>
<style lang="scss" scoped>
.modal-info {
  word-break: break-word;

  div {
    line-height: 24px;
  }
}

.btn-content {
  display: flex;
  justify-content: center;
  .el-button {
    @include buttonYellow;
  }
}
.color-white {
  color: #fff;
}

.tg-action {
  display: flex;
  align-items: center;
  padding: 10px 12px 0 12px;
  justify-content: space-between;

  &-item {
    padding: 0 10px;
    height: 30px;
    line-height: 30px;
    display: flex;
    align-items: center;
    border-radius: var(--radius-301);
    background: var(--button-300);
    @include text-ellipsis;
  }

  &-icon {
    margin-right: 4px;
    width: 17px;
    height: 17px;
  }

  &-name {
    font-size: 12px;
    color: var(--font-color-700);
    @include text-ellipsis;
  }
}

.el-dropdown-menu.el-popper {
  z-index: 99999;
  padding: 0;

  .qbHeaer,
  .qbFooter {
    cursor: auto;
  }

  .qbHeaer {
    padding: 0 10px;
    margin: 0 10px;
  }

  .el-icon-question {
    cursor: pointer;
    margin-left: 5px;
  }

  .qbItem {
    margin-bottom: 2px;
    padding: 0 10px;
    margin: 0 10px;
    border-bottom: 1px solid var(--border-color-100);
    color: var(--font-color-100);
  }

  .is-disabled {
    color: var(--font-color-300) !important;
    pointer-events: auto;
  }

  .qbFooter {
    text-align: center;
    height: 36px;
    padding: 8px 0;

    .walletBtn {
      cursor: pointer;
      line-height: 24px;
      padding: 6px 20px;
      display: inline-block;
      overflow: hidden;
      position: relative;
      @include buttonPrimary;

      &.first {
        &:before {
          content: "";
          position: absolute;
          width: 200px;
          height: 30px;
          /**白光的宽度，可根据实际调整**/
          background-image: linear-gradient(to bottom, transparent, rgba(255, 255, 255, 0.5), transparent);
          transform: rotate(-45deg);
          animation: searchLights 3s ease-in 1s infinite;
          /**第一个数字参数控制扫光速度，数字越大越慢**/
        }

        @keyframes searchLights {
          0% {
            left: -120px;
            top: -20px;
          }

          100% {
            left: 100px;
            top: 100px;
          }
        }
      }
    }
  }
}

.qbDiv {
  position: relative;
  padding: 0 120px 0 25px;
  &.experienceWrap {
    margin-bottom: 20px;
  }
  .experience_coin {
    line-height: 1;
    font-size: 12px;
    color: var(--font-color-1800);
    .el-icon-question {
      pointer-events: all;
      cursor: pointer;
      margin-left: 5px;
      font-size: 14px;
      color: var(--font-color-200);
    }
  }

  img {
    position: absolute;
    width: 16px;
    height: 16px;
    left: 0;
    top: 8.5px;
  }

  .chips {
    position: absolute;
    width: 120px;
    right: 0;
    top: 0;
    text-align: right;
  }
}
.experienceDiv{
  padding-left: 25px;
  padding-bottom: 5px;
}
</style>
